<template>
    <ScreenLayout ref="screenLayout">
        <template slot="header">
            <v-toolbar flat dark dense class="primary" xxstyle="z-index:8;position:fixed;">

                <v-btn @click.native="$router.push('/home')" icon>
                    <v-icon>chevron_left</v-icon>
                </v-btn>        
                <v-toolbar-title>Taco</v-toolbar-title>
                <v-spacer></v-spacer>
                <ToolbarSearch @search="search" debounced ref="searchBox" />

                <v-menu offset-y left>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on">more_vert</v-icon>
                    </template>
                    <v-list>
                        <v-list-item @click="makeContacts">
                            <v-list-item-title>Make 100 Contacts</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="makeGroups">
                            <v-list-item-title>Make Initial Groups</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="createInitialTeams">
                            <v-list-item-title>Make Initial Teams For This User</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="initSearchFields">
                            <v-list-item-title>Initialise Search Fields</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>  
                
                
            </v-toolbar>
        </template>
        <template slot="left">
            <div style="background-color:#e0e0e0;height:100%">

            <DataLoader @loaded="groupsLoaded" ref="groupsData" collection="groups" sort-field="name" :limit="40">
            <template v-slot:default="{items:groups}">

                <OneOrMoreList ref="groupsList" :items="groups" icon="mdi-account-group" @add="addGroup" @expanded="groupExpanded" @contracted="groupContracted" @selection-change="resetContactSelection(false)">
                    <template v-slot:selection>
                        <div class="ml-3 mr-3">

                            <div class="element-label">Show contacts that are in</div>
                            <v-btn-toggle v-model="joinSets" borderless dense >
                                <v-btn value="intersection">
                                    <span class="hidden-sm-and-down">All Groups</span>

                                    <v-icon right>mdi-vector-intersection</v-icon>
                                </v-btn>

                                <v-btn value="union">
                                    <span class="hidden-sm-and-down">Any Group</span>

                                    <v-icon right>mdi-vector-arrange-below</v-icon>
                                </v-btn>
                            </v-btn-toggle>
                        </div>
                    
                        <v-list-item @click="">
                            <v-list-item-title>Do Something</v-list-item-title>
                        </v-list-item>
                    </template>

                    <template v-slot:title="{item}">
                        <div class="swatch-container">
                            <v-chip dark small :color="item.colour || '#ccc'" style="margin:0px 5px 0 -3px;width:44px;text-align:center">{{item.members || '0'}}</v-chip>
                            <div>{{item.name}}</div>
                        </div>
                    </template>

                    <template v-slot:content="{item}">
                        <div class="pa-2">
                            <v-form>
                                <v-text-field v-model="item.name" ref="name" label="Name" hide-details></v-text-field>
                                <v-switch color="blue" v-model="item.favourite" label="Favourite" hide-details></v-switch>
                                <ColourBar :colours="colours" v-model="item.colour" label="Colour" class="mt-2" />
                            </v-form>
                            <div class="element-label mt-4">Actions</div>
                            <div class="action-menu">Email Group</div>
                            <div class="action-menu">Delete Group</div>
                            <div @click="addToGroup(item)" v-if="selectedContacts.length > 0" class="action-menu">Add Selected Contacts</div>
                        </div>
                    </template>
                </OneOrMoreList>
            </template>
            </DataLoader>
            <div class="pa-2">
                <v-btn @click="addGroup" class="full-width grey--text text--darken-1" color="grey lighten-2" rounded depressed style="margin: 0 auto;">Add a Group</v-btn>
            </div>
            </div>
        </template>
        
        <div class="pa-3 elevation-1 ma-3" style="overflow:auto;background-color:#f0f0f0">
             
             <!-- Contacts -->
            <DataLoader @loading="contactsLoading" @loaded="contactsLoaded" ref="contactsData" collection="contacts" :search="contactSearch" :conditions="groupsFilter" :sort-field="sortField" :limit="40">
                <template v-slot:default="{items:contacts}">
                    <OneOrMoreList :lock="Boolean(lock || addingRelationship)" hide-expander ref="contactsList" width="350px" :items="contacts" icon="mdi-account-user" @selection-change="contactSelectionChanged">
                        <template v-slot:selection>
                            <v-list-item @click="">
                                <v-list-item-title>Do Something</v-list-item-title>
                            </v-list-item>
                        </template>

                        <template v-slot:title="{item}">
                            <div class="swatch-container">
                                <img @click="avatarClicked(item)" class="contact-image mr-2" :src="item.image" alt="" >
                                <div class="contact-details">
                                    <div>
                                        {{item.firstName}} {{item.lastName}} <span style="font-weight:300" v-if="item.hasPartner"> +</span>
                                    </div>
                                    <div style="font-weight:300">
                                        {{item.mobile}} 
                                    </div>
                                    <div class="small-text" style="font-weight:300">
                                        {{getItemTeamName(item)}} 
                                    </div>
                                </div>
                                <v-btn @click.stop="sendEmail(item)" style="margin-top:-3px" @mousedown.stop icon color="grey lighten-1">
                                    <v-icon>email</v-icon>
                                </v-btn>
                            </div>
                        </template>
                    </OneOrMoreList>
                </template>
            </DataLoader>

        </div>
        

        <template slot="right">
            <div class="pa-3">

            <div v-if="lock" class="panel-multi pa-3 mb-3 rounded display-flex" style="border:dotted 4px #2E9AFE;background-color:white" key="lock" >
                <div style="flex-grow:1">
                    {{lock}}
                </div>
                <v-btn dark color="blue" @click="resetContactSelection(true)" small rounded depressed>Clear</v-btn>
            </div>
 
            <div style="position:relative" v-if="selectedContacts.length > 0" class="panel-multi white pa-3 rounded" key="base" >
                <!-- <div  height:20px;width:30px;cursor:pointer;" > -->
                    <v-btn v-if="!lock" style="position:absolute;top:5px;right:5px;z-index:100" @click="lock = 'Selection is locked on'" :color="(lock ? 'blue' : 'grey lighten-2')" icon>
                        <v-icon >lock</v-icon>
                    </v-btn>
                <!-- </div> -->
            
                <ContactImages :contacts="selectedContacts" :partners="contactsArePartners" />
                <!-- Multiple Contacts -->
                <!-- One Contact -->
                <div v-if="selectedContacts.length == 1">
                    <div key="one">
                        <div style="display:flex;flex-wrap:wrap">
                            <div style="flex-grow:10;flex-basis:200px;">
                                <v-text-field v-model="selectedContact.firstName" label="First Name" hide-details/>
                                <v-text-field v-model="selectedContact.lastName" label="Last Name" hide-details/>
                            </div>
                        </div>

                        <v-text-field v-model="selectedContact.email" label="Email" hide-details/>
                        <v-text-field v-model="selectedContact.mobile" label="Mobile" hide-details/>
                    </div>
                </div>


                <!-- 2 Contacts -->
                <div  v-if="selectedContacts.length == 2" class="white pa-3 rounded panel-multi" key="two" >
                    <div style="display:flex;align-content:center;font-size:12px;width:100%">
                        <div style="flex-grow:1;text-align:center">
                            <v-select v-if="addingRelationship" v-model="newRelationship" :items="relationshipNames" return-object hide-details style="width:110px;margin:0 auto;"/>
                        </div>
           
                        <div style="flex-grow:1;text-align:center">
                            <v-text-field v-if="addingRelationship" :value="newRelationship.relatedText" @keydown.stop.prevent hide-details style="width:110px;margin:0 auto;"/>
                        </div>
                    </div>
                    <div class="stretch-contents mt-3">
                        <template v-if="addingRelationship">
                            <v-btn @click="saveRelationship" rounded depressed>
                                Save Relationship
                            </v-btn>
                            <v-btn @click="addingRelationship = false" rounded depressed class="mt-2">
                                Cancel
                            </v-btn>
                        </template>
                        <template v-if="!addingRelationship">

                            <v-btn v-if="contactsArePartners" @click="separatePartners" rounded depressed>
                                <v-icon left color="grey">mdi-heart-broken</v-icon>
                                Separate
                            </v-btn>
                            <v-btn v-if="contactsCouldBePartners" @click="makePartners" rounded depressed>
                                <v-icon left color="grey">mdi-heart</v-icon>
                                Make Partners
                            </v-btn>
                            <div class="small-text light-text center-text" v-if="!contactsArePartners && !contactsCouldBePartners && !differentTeams">
                                Contacts have existing partner/s
                            </div>
                            <div class="small-text light-text center-text" v-if="differentTeams">
                                Contacts have different teams
                            </div>
                            <v-btn v-if="!differentTeams" @click="addingRelationship = true" rounded depressed class="mt-2">
                                Relate Contacts
                            </v-btn>
                        </template>
                    </div>
                </div>



            </div>

            <div v-if="this.selectedContacts.length == 0" class="white pa-3 rounded mt-0">
                    <div class="element-label mb-2">Sorted by {{sortField}}</div>
                    <v-btn @click="sortField = alternateSortField" rounded depressed class="full-width">
                        <v-icon class="mr-2">mdi-sort</v-icon>
                        Sort by {{alternateSortField}}
                    </v-btn>
            </div>

            <!-- Groups -->

            <div v-if="this.selectedContacts.length > 0" class="white pa-3 rounded mt-4" >
                    <div class="element-label">Groups</div>
                    <TagsView v-if="this.selectedContacts.length == 1" :tags="selectedContact.tags" :available-tags="this.groups" @remove="removeFromGroup" />
                    <GroupDropdown class="full-width" buttonClass="mt-2" :groups="groups" label="Add to Group" @new="addToNewGroup" @select="addToGroup" />
                    <GroupDropdown v-if="this.selectedContacts.length != 1" class="full-width" buttonClass="mt-2" :groups="groups" label="Remove from Group" existing-only @select="removeFromGroup" />
            </div>

            <!-- </transition> -->

            <!-- Relationships for Single -->

            <div v-if="this.selectedContacts.length == 1" class="white pa-3 rounded mt-4" key="relationships" >
                <div class="element-label">Relationships</div>

                <DataLoader v-model="singleRelationships" collection="relationships" :conditions="relationshipsFilter" :limit="10">
                    <template v-slot="{items: relationships}">
                        <template v-for="relationship in relationships">

                        <!-- <div class="hoverable clickable" style="display:flex;padding:4px;" :key="relationship._id">
                            <img class="contact-image white-border shadow" style="height:40px;width:40px;margin-right:20px" alt="" :src="relationship.relatedImage" >
                            <div style="flex-grow:1;font-size:14px">
                                <div>
                                    {{relationship.relatedFirstName}} {{relationship.relatedLastName}}
                                </div>
                                <div style="font-weight:300">
                                    {{relationship.relatedRelationship}}
                                </div>
                            </div>
                        </div> -->


                        <v-menu offset-y left :key="relationship._id">
                            <template v-slot:activator="{ on }">
                                <div v-on="on" class="hoverable clickable" style="display:flex;padding:4px;" :key="relationship._id">
                                    <img class="contact-image white-border shadow" style="height:40px;width:40px;margin-right:20px" alt="" :src="relationship.relatedImage" >
                                    <div style="flex-grow:1;font-size:14px">
                                        <div>
                                            {{relationship.relatedFirstName}} {{relationship.relatedLastName}}
                                        </div>
                                        <div style="font-weight:300">
                                            {{relationship.relatedRelationship}}
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <v-list>
                                <v-list-item @click="goToRelated(relationship)">
                                    <v-list-item-title>Go to {{relationship.relatedFirstName}}</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="removeRelationship(relationship)">
                                    <v-list-item-title>Remove this relationship</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>  
                        
                        

                        </template>
                    </template>
                        <template v-slot:empty>
                            <div style="display:flex;align-items:center">
                                <div style="font-size:24px;padding:3px 3px 0 3px">🤔</div>
                                <div class="light-text" style="font-size:14px">Totally unrelated</div>
                            </div>
                        </template>

                </DataLoader>

                <v-btn class="mt-2" @click="addRelationshipToIndividual" rounded depressed>Add Relationship</v-btn>
            </div>

            <!-- Download -->

            <div v-if="this.selectedContacts.length > 0" class="white pa-3 rounded mt-4" key="groups" >
                <div class="element-label">Download to Excel</div>  
                <VueJsonToCsv @success="downloadComplete" :jsonData="downloadableContacts" :labels="downloadableLabels(downloadableContacts)">
                    <v-btn depressed rounded class="full-width">
                        <v-icon color="grey lighten-1" left>mdi-cloud-download</v-icon>
                        Download
                    </v-btn>
                </VueJsonToCsv>   
            </div>
            

            </div>
            </div>
            
        </template>

    </ScreenLayout>
</template>

<script>
import DeleteButton from '@/ui-elements/DeleteButton'
import ColourBar from '@/ui-elements/ColourBar'

import OneOrMoreList from '@/ui-elements/OneOrMoreList'
import LayoutContainer2 from '@/ui-elements/LayoutContainer2'
import SectionLayout from '@/screens/SectionLayout'
import ElementLayout from '@/screens/ElementLayout'
import LayoutReadOnly from '@/ui-elements/LayoutReadOnly'
import ElementMenu from '@/screens/ElementMenu'
import ScrollHelpers from '../helpers/ScrollHelpers'
import ScreenLayout from '../screens/ScreenLayout'
import PageLayout from '../screens/PageLayout'
import VueJsonToCsv from 'vue-json-to-csv'

import DateRangeList from '@/ui-elements/DateRangeList'
import ToolbarSearch from '@/ui-elements/ToolbarSearch'
import TagsView from '@/ui-elements/TagsView'
import ScreenData from './ScreenData'
import ScreenTable from './ScreenTable'
import Utilities from '../helpers/Utilities'
import StringHelpers from '../helpers/StringHelpers'
import ArrayHelpers from '../helpers/ArrayHelpers'
import ContactHelpers from '../helpers/ContactHelpers'
import FakeHelpers from '../helpers/FakeHelpers'
import ContactRow from '../ui-elements/contacts/ContactRow'
import ImageGroup from '../ui-elements/ImageGroup'
import GroupDropdown from '../ui-elements/GroupDropdown'
import ContactImages from '../ui-elements/ContactImages'
import DataLoader from '../ui-elements/DataLoader'
import LookupData from '../helpers/LookupData'
import TagHelpers from '../helpers/TagHelpers'
import AlertHelpers from '../helpers/AlertHelpers'
import Firestore from '../data/Firestore'
import TeamHelpers from '../helpers/TeamHelpers'
import DataHelpers from '../helpers/DataHelpers'
import CollectionHelpers from '../helpers/CollectionHelpers'


import Collection from '../data/Collection'

export default {
    data() {
        return {
            user: {},
            joinSets: 'intersection',
            lock: '',

            
            addingRelationship: false,
            newRelationship: {
                text: 'Friend',
                relatedText: 'Friend'
            },

            colours: ['#FE2E2E', '#FE9A2E', '#31B404', '#0080FF', '#AC58FA', '#FE2E9A', '#848484'],

            sampleGroups: [
                {_id: 'clients', name: 'Clients', colour:'#31B404', members:983},
                {_id: 'firstHomeBuyers', name: 'First Home Buyers', members: 14},
                {_id: 'investors', name: 'Investors', colour: '#FE2E9A', members: 87},
                {_id: 'marketing4', name: 'Marketing 4', colour:'#31B404', members:44},
                {_id: 'builders', name: 'Builders', members: 13, colour: '#AC58FA'},
                {_id: 'agents', name: 'Agents', colour: '#0080FF', members: 20},
            ],

            contacts: [],
            groups: [],
            lockedContacts: [],

            singleRelationships: [],
            coupleRelationships: [],
            contactSearch: '',
            sortField: 'firstName'
        
        }
    },
    components: {
        DeleteButton,
        ColourBar,
        OneOrMoreList,
        SectionLayout,
        ScreenLayout,
        ScreenTable,
        DateRangeList,
        VueJsonToCsv,
        ContactRow,
        ImageGroup,
        TagsView,
        GroupDropdown,
        ContactImages,
        ToolbarSearch,
        DataLoader,
    },
    
    props: {

    },

    computed: {

        downloadableContacts() {
            return this.selectedContacts.map( c => {
                let newItem = {...c}
                newItem.id = newItem._id
                delete newItem.createdAt
                delete newItem.updatedAt
                delete newItem.createdBy
                delete newItem.updatedBy
                if(newItem.tags) {
                    newItem.tags = TagHelpers.tagsToString(newItem.tags)
                }
                newItem = Firestore.removeMeta(newItem)
                return newItem
            })
        },

        alternateSortField() {
            return (this.sortField == 'firstName' ? 'lastName' : 'firstName')
        },

        offices() {
            return this.$store.getters.offices
        },

        // officesActive() {
        //     return this.$store.getters.officesActive
        // },

        // currentOffice() {
        //     return this.offices.find(o => o.meta.key == this.tenantKey)
        // },

        selectedGroups() {
            return this.groups.filter(o => o._selected)
        },

        groupsFilter() {
            let filters = []
            this.selectedGroups.forEach(group => {
                filters.push( {
                    field: 'tags.' + group._id,
                    operator: '==',
                    value: true,
                })
            })
            return filters
        },

        relationshipsFilter() {
            return [{field: 'primaryId', operator: '==', value:this.selectedContact._id}]
        },

        selectedNames() {
            return StringHelpers.sentenceJoin(this.selectedContacts.map(o => o.firstName))
        },
        selectedImages() {
            return this.selectedContacts.map(o => o.image)
        },
        selectedContact() {
            return this.selectedContacts[0]
        },

        selectedContacts() {
            return this.contacts.filter(o => o._selected)
        },

        relationshipNames() {
            return LookupData.relationships().filter(o => o.text != 'Partner')
        },
        contactsCouldBePartners() {
            const c1 = this.selectedContacts[0]
            const c2 = this.selectedContacts[1]
            if(!c1 || !c2)
                return false
            if(this.differentTeams)
                return false
            return (!c1.hasPartner && !c2.hasPartner)
        },

        contactsArePartners() {
            return Boolean(this.coupleRelationships.find(r => r.relatedRelationship == 'Partner'))
        },

        differentTeams() {
            if(this.selectedContacts.length < 2)
                return false
            let different = false
            const team = Firestore.getItemTeam(this.selectedContacts[0])
            this.selectedContacts.forEach(contact => {
                
                if(Firestore.getItemTeam(contact) != team)
                    different = true
            })
            return different
        }

    },

    methods: {  
        downloadableLabels(collection) {
            const item = collection[0]
            let labels = {}
            for(let prop in item) {
                labels[prop] = {title: StringHelpers.camelToNormal(prop)}
            }
            return labels
        },

        downloadComplete() {
            AlertHelpers.showAlert(`${this.selectedContacts.length} rows downloaded. See below`)
        }, 

        avatarClicked(item) {
            Firestore.consoleLogPath(item)
        },

        search(term) {
            this.contactSearch = term
            console.log('search for ' + term)
        },

        contactsLoading() {
            if(this.lock) {
                this.lockedContacts = []
                this.selectedContacts.forEach(selectedContact => {
                    this.lockedContacts.push(selectedContact)
                })
            }

        },

        contactsLoaded(contacts) {
            this.contacts = contacts
            
            if(this.lock) {
                this.lockedContacts.forEach(lockedContact => {
                    CollectionHelpers.insertOrMoveToTop(lockedContact, this.contacts)
                })
            }
        },

        groupsLoaded(groups) {
            this.groups = groups
        },

        getItemTeamName(contact) {
            return StringHelpers.camelToNormal(Firestore.getItemTeam(contact) )
        },
        createInitialTeams() {
            const userKey = DataHelpers.getUserId()
            this.offices.forEach(office => {
                console.log(office)
                let team = {
                    _id: StringHelpers.toCamelCase(office.name),
                    _new: true,
                    active: false,
                    legacyNumber: office.meta.key,
                    _path: `users/${userKey}/teams`
                }
                Firestore.saveItem(team)
                let role = {
                    _id: StringHelpers.toCamelCase(office.name),
                    _new: true,
                    read: true,
                    write: true,
                    _path: `users/${userKey}/roles`
                }
                Firestore.saveItem(role)
            })
        },

        initSearchFields() {
            debugger
            this.contacts.forEach(contact => {
                contact.search1 = contact.firstName.toLowerCase()
                contact.search2 = contact.lastName.toLowerCase()
                contact.relationships = Firestore.deleteToken()
                Firestore.saveItem(contact)
            })
        },

        resetContactSelection(force) {
            this.$refs.searchBox.clear()
            if(force)
                this.lock = ''
            if(!this.lock)
                this.$refs.contactsList.unselectAll()
        },

        async contactSelectionChanged() {
            this.loadCoupleRelationships()
        },

        async loadCoupleRelationships() {
            if(this.selectedContacts.length!== 2) { 
                this.coupleRelationships = []
                return
            }
            const c1 = this.selectedContacts[0]
            const c2 = this.selectedContacts[1]
            if(Firestore.getItemTeam(c1) !== Firestore.getItemTeam(c1)) { 
                this.coupleRelationships = []
                return
            }

            this.coupleRelationships = await ContactHelpers.fetchCoupleRelationships(c1, c2)
            console.log('couple relates = ', this.coupleRelationships)
        },

        addToGroup(group) {
            const result = TagHelpers.addTagToItems(group, this.selectedContacts)
            this.saveSelectedContacts()
            AlertHelpers.showAlert(result.message)
        },

        saveSelectedContacts() {
            this.selectedContacts.forEach(contact => {
                Firestore.saveItem(contact, {merge: false})
            })
        },

        removeFromGroup(group) {
            const result = TagHelpers.removeTagFromItems(group, this.selectedContacts)
            this.saveSelectedContacts()
            AlertHelpers.showAlert(result.message)
        },

        addToNewGroup(name) {
            const newGroup = this.addGroup(name, {silent:true})
            this.addToGroup(newGroup)
        }, 

        makePartners() {
            this.lock = false
            ContactHelpers.makePartners(this.selectedContacts[0], this.selectedContacts[1], this.coupleRelationships)
        },

        separatePartners() {
            ContactHelpers.separatePartners(this.selectedContacts[0], this.selectedContacts[1], this.coupleRelationships)
        },

        contactPartnerId(contact) {
            return ContactHelpers.contactPartnerId(contact)
        },

        addGroup(name = this.uniqueGroupName(), options={}) {
            const newGroup = {
                _id: StringHelpers.toCamelCase(newGroup),
                colour: ArrayHelpers.randomFromArray(this.colours),
                name,
            }
            this.groups.unshift(newGroup)
            if(!options.silent)
                this.$refs.groups.expand(newGroup)
            return newGroup
        },

        getGroupColour(name) {
            //todo: get from db
            const groups = this.groups
            const group = groups.find(g => g._id == name )
            if(group)
                return group.colour
            else
                return null
        },

        swatchStyle(item) {
            return 'background-color:' + item.colour
        },      

        groupExpanded(item) {
            console.log('expanding with focus')
            Firestore.trackChanges(item)
            const select = Boolean(item.name == this.uniqueGroupName())
            Utilities.focus(this, 'name', select)
        },

        groupContracted(item) {
            console.log('Contracting', item)
            let changes = Firestore.getChanges(item, item._originalValues)
            if(changes.hasChanges)
                Firestore.saveItem(item)
        },

        uniqueGroupName() {
            let name
            for(var n= 1; n < 99; n++) {
                name = 'Group ' + n.toString()
                if(this.groups.findIndex(o => o.name == name) < 0)
                    break
            }
            return name
        },

        saveRelationship() {
            this.lock = false
            ContactHelpers.relateContacts(this.selectedContacts[0], this.newRelationship.text, this.selectedContacts[1], this.newRelationship.relatedText, this.coupleRelationships)
            this.addingRelationship = false
        },

        addRelationshipToIndividual() {
            this.lock = "Adding Relationship. Choose another person."
            document.getElementsByClassName('right-column')[0].scrollTop = 0
        },

        setLockMessage() {
            if(!this.lock || this.lock.indexOf('Adding Relationship') < 0)
                return
            //only proceed if in adding mode...
            if(this.selectedContacts.length == 1)
                this.lock = 'Adding Relationship. Select another...'
            else if(this.selectedContacts.length == 2)
                this.lock = 'Adding Relationship. Click below...'
            else
                this.lock = 'Adding Relationship. Choose 2 contacts...'
         
        },

        async goToRelated(relationship) {
            Firestore.consoleLogPath(relationship)


            const id = relationship.relatedId
            const team = Firestore.getItemTeam(relationship)
            const collection = 'contacts'
            
            const ref = await Firestore.ref({team, collection, id})
            const contact = await Firestore.fetch(ref)

            const edRef = await Firestore.ref({team, collection}).where('firstName', '==', 'Edward')
            const edItems = await Firestore.fetch(edRef)

            this.$refs.contactsData.addItem(contact)
            this.$refs.screenLayout.$refs.middleColumn.scrollTop = 0
            this.$refs.contactsList.selectOne(contact)
            
            console.log(contact)
        },

        async hydrateRelationships(contact) {
            if(!contact)
                return
            const relationships = await ContactHelpers.fetchRelationships(contact)
        
            this.selectedRelationships = relationships
        },

        sendEmail(contact) {
            AlertHelpers.showAlert('Email to be sent here to ' + ContactHelpers.fullName(contact))
        },

        async removeRelationship(relationship) {
            if(await this.$root.$confirm('Delete Relationship', `Remove association between ${relationship.primaryFirstName} and ${relationship.relatedFirstName}?`, { color: 'red' }) == true) {
            }
        },

        async makeContacts() {
            const contacts = FakeHelpers.fakeContacts(100)    
            const teamName = this.user.primaryTeam
            
            FakeHelpers.fakeGroups(contacts)
            const relationships = FakeHelpers.fakeRelationships(contacts)    
            contacts.forEach(contact => {
                
                contact._team = teamName
                contact._collection = 'contacts'
                Firestore.saveItem(contact)
            })     
            relationships.forEach(relationship => {

                relationship._team = teamName
                relationship._collection = 'relationships'
                Firestore.saveItem(relationship)
            })     
            
        },

        makeGroups() {
            debugger
            this.sampleGroups.forEach(group => {
                group._team = this.user.primaryTeam
                group._collection = 'groups'
                Firestore.saveItem(group)
            })
        }

    },

    mounted() {

    },

    watch: {
        'selectedGroups': {
            handler: function(newVal) {
                if(!this.lock)
                    this.$refs.contactsList.unselectAll()
            },
            deep: true,
        },
        'selectedContact': {
            handler: function(newVal) {
                this.hydrateRelationships(newVal)
                this.setLockMessage()

            }
        }
    },

    

    async created() {

        console.log('User is ' + DataHelpers.getUserId())
        
        const uid = await TeamHelpers.fetchUserId(this)

        TeamHelpers.streamUser(this.user)

    }

}
</script>

<style scoped>

    .stretch-contents > * {
        width:100%
    }

    .item-container { padding:4px 8px;}
    .item-row {
        display: flex;
        
        border: solid 3px transparent;
        border-radius:10px;
        background-color: #fff;
        color:#666
    }

    .item-check-column {
        padding-top:7px;
        padding-left:2px;
    }

    .item-text-column {
        padding: 8px;
        flex-grow: 1;
    }

    .item-button-column {
        padding-top:2px;
    }

    .item-row.selected {
        border: dashed 3px #4ca3dd;
    }
    .item-row:hover:not(.selected) {
        border: dashed 3px #ddd;
    }

    .selected .item-check-column i {
        color: #4ca3dd;
    }
    .item-check-column i:hover {
        color: #4ca3dd;
    }
    .item-check-column i {
        color: #ddd;
    }
    .swatch {
        width:4px;height:16px;margin-top:3px;border-radius:2px;margin-right:6px;margin-left:-5px;
    }
    .swatch-container {
        display:flex; 
    }
    .action-menu {
        text-align:center;
        font-size:14px;
        padding:8px;
        border-top: solid 1px #ddd;
        border-bottom: solid 1px #ddd;
        margin-top: -1px;
        border-radius:6px;
    }
    .action-menu:hover {
        background-color:rgba(0,0,0,0.1)
    }

    .contact-details {
        flex-grow: 1;
    }

    .contact-image {
        width:48px;
        height:48px;
        border-radius:50%;
    }
   
</style>




// WEBPACK FOOTER //
// GridScreen.vue?6c4afff5